import { useEffect } from "react";

// Static OG / Twitter head tags for the homepages. React 19-compatible native
// head management (same approach as BoardSeo, no Helmet dependency).
function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

const OG_TITLE = "PodiumOne — Own Any Keyword. Hold the Throne.";
const OG_DESCRIPTION =
  "Live keyword auction arena where brands and creators battle to own the #1 spot on any topic. One bid. One throne. King of the Hill, not a subscription.";
const OG_IMAGE = "https://podiumone.to/og-image.png";

export function HomeSeo({ ogUrl = "https://podiumone.to" }) {
  useEffect(() => {
    document.title = OG_TITLE;
    upsertMeta("name", "description", OG_DESCRIPTION);
    upsertMeta("property", "og:title", OG_TITLE);
    upsertMeta("property", "og:description", OG_DESCRIPTION);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:image", OG_IMAGE);
    upsertMeta("property", "og:url", ogUrl);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", OG_TITLE);
    upsertMeta("name", "twitter:description", OG_DESCRIPTION);
    upsertMeta("name", "twitter:image", OG_IMAGE);
  }, [ogUrl]);
  return null;
}
